import { inject, Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { SparketBridgeApi } from '../../api/sparket-bridge/sparket-bridge-api';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public get sparketToken(): string | undefined {
    return this.jwtToken;
  }

  private httpService = inject(HttpService);
  private analyticsService = inject(AnalyticsService);

  private sparketUserId?: string;
  private sparketUsername?: string;
  private jwtToken?: string;

  public async initialise(sparketUserId: string, sparketUsername: string, jwtToken: string) {
    this.sparketUserId = sparketUserId;
    this.sparketUsername = sparketUsername;
    this.jwtToken = jwtToken;
  }

  public async generateThndrToken(): Promise<string> {
    const data = await SparketBridgeApi.request(
      this.httpService,
      this.analyticsService,
    ).generateToken(this.sparketUsername ?? '');
    return data?.token ?? '';
  }
}
